import React from "react";
import classNames from "classnames";
import { Input as UIInput, InputProps as UIInputProps } from "@stemscopes/ui";
import styles from "./StyledInternalInput.module.css";

// Supposed to be using only by other inputs
// Should not be used in features directly due to lack of error handling

const StyledInternalInput: React.FC<
  UIInputProps & {
    error: boolean | string | undefined;
  }
> = ({
  labelClassName,
  inputClassName,
  clearClassName,
  error,
  required,
  ...rest
}) => {
  return (
    // eslint-disable-next-line
    // @ts-ignore
    <UIInput
      {...rest}
      labelClassName={classNames(styles.label, labelClassName)}
      inputClassName={classNames(styles.input, inputClassName, {
        [styles.error]: error,
        [styles.inputWithoutLabel]: !rest.label || rest.labelHidden,
      })}
      clearClassName={classNames(styles.clearButton, clearClassName)}
      aria-required={required}
    />
  );
};

export default StyledInternalInput;
